
import $ from 'jquery';
import ko from 'knockout';
import _ from 'lodash';
import moment from 'moment-timezone';
import FormatterCommon from './formatter-common';
import GridFormatterCommon from './grid-formatter-common';
import xml2json from '../xml2json';
import 'core-js/es/array';

function ComposeData(metadata, sourcelist, options, datasetmetadata) {
    var result = {};

    if (!_.isEmpty(metadata) && !_.isEmpty(options) && sourcelist) {
        var formatterCommon = FormatterCommon;
        var gridFormatter = new GridFormatterCommon();

        var metricKey = _.toLower(options.selectedMetricColumnNames[0]);
        var groupKey = _.toLower(options.selectedGroupColumnNames[0]);

        var metric = _.find(metadata.Table, ['columnKey', metricKey]);
        var group = _.find(metadata.GroupCols, ['columnKey', groupKey]);

        if (options.type === 'Table') {
            result = ComposeSummaryData(sourcelist, options, datasetmetadata);
            formatTable(result, formatterCommon, group, metric);
        }
        else {
            var maxGroups = options.maxGroups ? options.maxGroups : (options.type === 'Trend' ? 5 : 9);
            var sortColIndex = (options.type === 'Trend' ? 1 : 0);

            var composeConfig = {
                metric: metric,
                group: group,
                maxGroups: maxGroups,
                uniqueSort: {
                    groups: ['meetingdurationclass', 'participantdurationclass', 'packetlossclass', 'participantcountclass', 'qualityclass'],
                    meetingdurationclass: sortByName,
                    participantdurationclass: sortByName,
                    packetlossclass: sortByName,
                    participantcountclass: sortByName,
                    qualityclass: sortByQuality,
                    sortColIndex: sortColIndex
                },
                formatters: {
                    formatterCommon: formatterCommon,
                    gridFormatter: gridFormatter
                }
            };

            if (options.type === 'Trend') {
                result = ComposeTrendData(sourcelist, options, composeConfig);

            } else if (options.type === 'Pie') {
                result = ComposeDistributionData(sourcelist, options, composeConfig);
            }

            if (!_.isEmpty(result.headers)) {
                result.headers = formatterCommon.transformHeaders(result.headers, group, metric);
            }
        }
        result.metadata = metadata;
    }
    return result;
}

function ComposeDistributionData(sourcelist, options, config) {
    var j;

    if (_.isEmpty(sourcelist)) {
        return { datasets: [], xAxisCategories: 0, totalValue: 0 };
    }

    if (isDisplayTable(options)) {
        return composeTable(sourcelist, options, config);
    }

    var group = config.group,
        metric = config.metric,
        maxGroups = config.maxGroups,
        uniqueSortGroups = config.uniqueSort.groups;


    if (_.isEmpty(metric)) {
        return { datasets: [], xAxisCategories: 0, totalValue: 0 };
    }


    var result = getGridData(sourcelist, options);

    var distributionData = [], sum = 0;
    var metricDescription = metric.columnDescription;

    for (j = 0; j < sourcelist.length; j++) {
        var dataset = sourcelist[j];
        var datasetName = group ? dataset[group.columnName] : metricDescription;

        if (!datasetName && datasetName !== 0) {
            datasetName = 'Unknown';
        }

        distributionData.push({ name: datasetName, y: dataset.aggregateFact });

        sum += dataset.aggregateFact;
    }

    if (needsUniqueSorting(group, uniqueSortGroups)) {
        distributionData = config.uniqueSort[group.columnName](distributionData, 'name');
    }

    if (distributionData.length > (maxGroups + 1)) {
        distributionData = reduceDatasets(distributionData, maxGroups, metric.aggregateFunction, false);
    }

    result.xAxisCategories = _.map(distributionData, 'name');
    result.dataArray = _.map(distributionData, 'y');

    result.datasets = [{ name: metric.columnDescription, data: distributionData }];

    return result;
}

function ComposeSummaryData(sourcelist, options, metadata) {
    if (_.isEmpty(sourcelist)) {
        return {
            rows: [],
            headers: ['', ''],
            widths: ['10%', '90%'],
            maxCount: 0
        };
    }

    var list = [];
    var xml = sourcelist[0][''];
    var retJson = xml2json(xml);

    if (retJson && retJson.detail && retJson.detail.row) {
        list = retJson.detail.row;
    }

    if (!$.isArray(list)) {
        list = [list];
    }

    var formattedmetadata = GetSummaryMetadata(metadata);

    return getGridData(list, options, formattedmetadata);
}

function composeTable(sourcelist, options, config) {
    var gridData = getGridData(sourcelist, options);
    var group = config.group;
    var uniqueSortGroups = config.uniqueSort.groups;

    if (needsUniqueSorting(group, uniqueSortGroups) && options.sortIndex === config.uniqueSort.sortColIndex) {
        var sortOrder = options.sortAsc ? 'asc' : 'desc';
        var sortedRows = config.uniqueSort[group.columnName](sourcelist, group.columnName, sortOrder);

        gridData.rows = config.formatters.gridFormatter.pageList(sortedRows, options);
    }

    formatRows(gridData.rows, config.formatters.formatterCommon);

    return gridData;
}

function ComposeTrendData(sourcelist, options, config) {
    if (_.isEmpty(sourcelist)) {
        return { datasets: [], xaxislabels: [] };
    }

    if (isDisplayTable(options)) {
        return composeTable(sourcelist, options, config);
    }

    var group = config.group,
        metric = config.metric,
        maxGroups = config.maxGroups,
        uniqueSortGroups = config.uniqueSort.groups;

    let sortBy = _.isEmpty(sourcelist) ? '' :
        sourcelist[0].periodStartDate ? 'periodStartDate' :
            sourcelist[0].reporttime ? 'reporttime' : '';

    if (sortBy) {
        sourcelist = _.sortBy(sourcelist, s => s[sortBy]);
    }

    var result = getGridData(sourcelist, options);

    let times = (sortBy) ? _.sortedUniq(sourcelist.map(s => s[sortBy])) : [null];

    let factor = (metric && metric.percentageFlag) ? 100 : 1;
    var datasets = groupDatasets(sourcelist, times, metric, group, factor);

    if (needsUniqueSorting(group, uniqueSortGroups)) {
        datasets = config.uniqueSort[group.columnName](datasets, 'name');
    }

    if (datasets.length > (maxGroups + 1)) {
        datasets = reduceDatasets(datasets, maxGroups, metric.aggregateFunction, true);
    }

    result.datasets = datasets;

    if (metric && metric.percentageFlag) {
        result.ylabelSuffix = '%';
    }

    return result;
}

function findMetadataItem(metadata, key) {
    var mds = $.grep(metadata, function (mditem) {
        return mditem.columnKey === key;
    });
    return _.isEmpty(mds) ? null : mds[0];
}

function FlexiPanelFormatter(params, observableOptions, dataSources, panelId) {
    var self = this;

    self.panelId = panelId;
    self.observableOptions = observableOptions;
    self.gridFormatterCommon = new GridFormatterCommon();
    self.dataSources = dataSources;
    self.sourcetype = params && params.type ? params.type : '';
    self.datapresorted = params && params.datapresorted ? params.datapresorted : false;
    self.dataprepaged = params && params.dataprepaged ? params.dataprepaged : false;
    self.observableParams = dataSources[0].observableParams;
    self.observableFormattedData = ko.observable({});
    self.subscriptions = [];
}

FlexiPanelFormatter.prototype.DataUpdated = function () {
    var self = this;
    var metadata = self.dataRepository.flexQueryMetaData();

    if (_.isEmpty(self.metadata) && !_.isEmpty(metadata)) {
        // metadata was cached, we won't get MetadataUpdated called
        self.metadata = metadata;
    }
    // update sourceList ONLY when data is updated, not when metadata updates
    if (!_.isEmpty(ko.unwrap(self.observableParams))) {
        self.sourceList = self.dataRepository.getDictionaryValue(self.dataRepository.FlexQueryResultDictionary, self.observableParams());
    }
    self.RefreshData();
};

FlexiPanelFormatter.prototype.MetadataUpdated = function () {
    var self = this;
    self.metadata = self.dataRepository.flexQueryMetaData();
    self.datasetmetadata = self.dataRepository.historicalMetadataXml();
    self.RefreshData();
};

FlexiPanelFormatter.prototype.dispose = function () {
    this.subscriptions.forEach(function (sub) {
        sub.dispose();
    });
};

FlexiPanelFormatter.prototype.getObservableData = function () {
    return this.observableFormattedData;
};

FlexiPanelFormatter.prototype.initialize = function (dataRepository, dataProvider) {
    var self = this;

    self.dataRepository = dataRepository;
    self.dataProvider = dataProvider;

    self.subscriptions.push(self.dataRepository.FlexQueryResultDictionary.subscribe(function () {
        if (self.dataRepository.lastPanelId === self.panelId) {
            self.DataUpdated();
        }
    }));

    self.subscriptions.push(self.dataRepository.flexQueryMetaData.subscribe(function () {
        self.MetadataUpdated();
    }));

    self.RefreshData();
};

FlexiPanelFormatter.prototype.OptionsUpdated = function () {
    this.RefreshData();
};

FlexiPanelFormatter.prototype.RefreshData = function () {
    var self = this;
    var formattedData = ComposeData(
        self.metadata,
        self.sourceList,
        self.observableOptions(),
        self.datasetmetadata);

    if (!_.isEmpty(formattedData)) {
        self.observableFormattedData(formattedData);
    }
};

function formatRows(rows, formatter) {
    rows.forEach(function (row) {
        if (row.aggregateFact) {
            row.aggregateFact = formatter.formatNumeric(row.aggregateFact, true);
        }

        if (row.periodStartDate) {
            row.periodStartDate = formatter.formatDate(row.periodStartDate);
        }

        Object.entries(row).forEach(([key, value]) => {
            row[key] = formatter.sanitize(value);
        })
    });
}

function formatTable(table, formatter, group, metric) {
    table.rows = formatRows(table.rows, formatter.formatNumeric);
    table.headers = formatter.transformHeaders(table.headers, group, metric);
}

function formatValue(metadata, key, value) {
    if (!value) {
        return value;
    }
    var mds = findMetadataItem(metadata, key);
    return (mds && (mds.datatype === 'numeric')) ? parseFloat(value).toFixed(0) : value;
}

function getGridData(rows, options, metadata) {
    if (_.isEmpty(rows)) {
        return { rows: [], headers: [], widths: ['10%', '90%'], maxCount: 0 };
    }

    var keys = Object.keys(rows[0]);
    var header = $.map(keys, function (item) {
        if (item.indexOf('_') !== 0) {
            return item.replace(/.*\./, '');
        }
    });

    var finallist = rows;
    var finalkeys = [];
    var maxcount = rows.length;
    var idcol = '_rowID';

    if (!_.isEmpty(keys) && !_.isEmpty(metadata)) {
        header = [];

        for (var ind = 0; ind < keys.length; ind++) {
            var key = keys[ind];

            if (key.indexOf('_') === 0) {
                continue;
            }

            var mds = findMetadataItem(metadata, key);

            if (mds) {
                if (mds.coltype === 'id') {
                    idcol = key;
                }

                else {
                    header.push(mds.columnDescription);
                    finalkeys.push(key);
                }

            } else {
                header.push(key.replace(/.*\./, ''));
                finalkeys.push(key);
            }
        }
    }

    var display = [];
    var divisor = header.length;
    var eachwidth = Math.floor(100 / divisor);
    var widths = [];

    for (var i = 0; i < header.length; i++) {
        widths.push(eachwidth + '%');
    }

    if (finalkeys.length > 0) {
        var pageCountAttr = '_pageCount';
        var pageIDAttr = '_pageID';
        var recordCountAttr = '_recordCount';

        finallist = [];

        rows.forEach(function (rowitem) {
            var tempobj = {};

            if (idcol && rowitem[idcol]) {
                tempobj.id = rowitem[idcol];
            }
            finalkeys.forEach(function (keyitem) {
                tempobj[keyitem] = formatValue(metadata, keyitem, rowitem[keyitem]);
            });
            if (rowitem[recordCountAttr]) {
                maxcount = rowitem[recordCountAttr];
            }
            if (rowitem[pageIDAttr]) {
                tempobj[pageIDAttr] = rowitem[pageIDAttr];
            }
            if (rowitem[pageCountAttr]) {
                tempobj[pageCountAttr] = rowitem[pageCountAttr];
            }
            finallist.push(tempobj);
        });

        if (finallist.length > 0) {
            display = Object.keys(finallist[0]);
        }

        if ((finallist.length > 0) && (finallist[0].id)) {
            widths.unshift('0%');
            header.unshift('id');
        }

    } else {
        var gfc = new GridFormatterCommon();

        if (_.has(rows, '[0]')) {
            display = Object.keys(rows[0]);
        }
        finallist = gfc.pageList(rows, options);
    }

    return {
        rows: finallist,
        headers: header,
        rowProperties: display,
        widths: widths,
        maxCount: maxcount,
        display: display
    };
}

function GetSummaryMetadata(summarymetadata) {
    if (_.isEmpty(summarymetadata) || $.isEmptyObject(summarymetadata[0])) {
        return [];
    }

    var list = [];
    var xml = summarymetadata[0][''];
    var retJson = xml2json(xml);

    if (retJson && retJson.detail && retJson.detail.row) {
        list = retJson.detail.row;
    }

    if (!$.isArray(list)) {
        list = [list];
    }

    return list;
}

// used to group datasets by time for trend panels
// the output is an array of objects where each object has grouName and data
// data - an array of arrays where the first element is a date in miliseconds, second - value (number of calls, participants...)
function groupDatasets(sourcelist, times, metric, group, factor = 1) {
    let datasetsMap = {};

    for (let i = 0; i < sourcelist.length; i++) {
        let sourceItem = sourcelist[i];
        let itemKey = group ? sourceItem[group.columnName] : sourceItem.name;

        let itemKeyLower = _.toLower(itemKey);
        sourceItem.itemKey = itemKey;
        sourceItem.lowerItemKey = itemKeyLower;
    }

    for (let t = 0; t < times.length; t++) {
        /**
         * Could be day, month, week, year
         * Example: selected time range - November 1-30. Time grain - week. Data will contain 4 elements. one for each week...
         */
        let timeSpan = times[t];
        let timestamp = moment.utc(timeSpan).valueOf();

        for (let i = 0; i < sourcelist.length; i++) {
            let sourceItem = sourcelist[i];
            let sourceItemTime = sourceItem.periodStartDate || sourceItem.reporttime;

            let datasetGroup = datasetsMap[sourceItem.lowerItemKey] || { data: [], sum: 0, name: sourceItem.itemKey };
            datasetsMap[sourceItem.lowerItemKey] = datasetGroup;

            let inSelectedDateRange = (timeSpan === sourceItemTime);

            let aggregationValue = inSelectedDateRange ? (factor * sourceItem.aggregateFact) : 0;

            /**
             * If dataset with the same name and time already exist - add values together
             */
            let datum = datasetGroup.data[t];
            if (datum) {
                datum[1] += aggregationValue;

            } else {
                datasetGroup.data.push([timestamp, aggregationValue]);
            }

            datasetGroup.sum += (inSelectedDateRange ? sourceItem.aggregateFact : 0);
        }
    }

    var datasets = [];

    for (let key in datasetsMap) {
        let series = datasetsMap[key];

        let seriesName = group ? series.name : (metric && metric.columnDescription
            || series.name);
        if (seriesName !== null && seriesName !== undefined) {
            seriesName = '' + seriesName; // coerce to string
        }
        datasets.push({
            name: seriesName,
            data: series.data,
            sum: series.sum
        });
    }

    return datasets;
}

function isDisplayTable(options) {
    return options.selectedDisplayType === 'Table';
}

function needsUniqueSorting(group, uniqueSortGroups) {
    return !_.isEmpty(group) && $.inArray(group.columnName, uniqueSortGroups) >= 0;
}

const aggregateFunctionMap = {
  sum: (final, current) => final + current,
  max: (final, current) => (final > current ? final : current),
  avg: (final, current, length) => (final + (current / length)),
};
const aggregateFunctionLabels = {
    sum: '',
    max: ' (max)',
    avg: ' (average)',
}

// combines redundant datasets into one.
function reduceDatasets(datasets, maxItems, aggregateFunction, isTimeSeries) {
    let label = aggregateFunctionLabels[aggregateFunction] || '';
    let allOthersDataset = { name: ('All Others' + label) };
    if (isTimeSeries) {
        datasets = _.orderBy(datasets, ['sum'], ['desc']);
    } else {
        datasets = _.orderBy(datasets, ['y'], ['desc']);
        allOthersDataset.y = 0;
    }

    if (!aggregateFunctionMap[aggregateFunction]) {
        aggregateFunction = 'sum';
    }

    let allOthersData = [];

    let extraDatasets = datasets.splice(maxItems);

    extraDatasets.forEach((dataset) => {
        if (isTimeSeries) {
            dataset.data.forEach((data, j) => {
                let currentValue = data[1];
                if (!allOthersData[j]) {
                    // first element in an array is a time, second - value.
                    let time = datasets[0].data[j][0];
                    // init time/value pair
                    allOthersData[j] = [time, 0];
                }
      
                let allOthersValue = allOthersData[j][1];
                allOthersData[j][1] = aggregateFunctionMap[aggregateFunction](allOthersValue, currentValue, extraDatasets.length);
            });
            allOthersDataset.data = allOthersData;
        } else {
            let allOthersValue = dataset.y;
            allOthersDataset.y = aggregateFunctionMap[aggregateFunction](allOthersValue, allOthersDataset.y, extraDatasets.length);
        }
    });

    datasets.push(allOthersDataset);

    return datasets;
}

function sortByDuration(datasets, key, order) {
    var sortedDatasets = _.orderBy(datasets, function (item) {
        var valueSymbol = (item[key][0] === '>' || item[key][0] === '<');

        if (valueSymbol) {
            var value = item[key].replace(/\D/g, '');
            value = valueSymbol === '>' ? value + 1 : value - 1;
            return value;
        }

        return Number(item[key].split(/[\D,]+/)[0]);

    }, order);

    return sortedDatasets;
}
function sortByName(datasets) {
    var sortedDatasets = _.orderBy(datasets, ['name'], ['asc']);

    return sortedDatasets;
}

function sortByQuality(datasets) {
    var sortedDatasets = _.orderBy(datasets, n => {
        const order = {
            'Good': 1,
            'Fair': 2,
            'Bad': 3,
            'Unknown': 4
        };
        return order[n.name] || 5;
    }, ['asc']);

    return sortedDatasets;
}

export default FlexiPanelFormatter;
